import { footerData } from "../data/mock";
import { navData } from "../data/mock";
import { Youtube, Instagram, Linkedin, ArrowUpRight, Mail } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      className="relative py-14"
      style={{ background: "#252422" }}
    >
      <div className="max-w-[87.5rem] mx-auto px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div className="flex items-start gap-3">
            <img
              src={navData.logo}
              alt="Rahul Taneja"
              className="w-11 h-11 rounded-full object-cover object-top border border-[#3f4816]/30"
            />
            <div>
              <p
                className="text-[#dfddd6] text-sm font-bold mb-0.5"
                style={{ fontFamily: "'Inter', Arial, sans-serif" }}
              >
                {footerData.name}
              </p>
              <p
                className="text-[#888680] text-xs"
                style={{ fontFamily: "'Inter', Arial, sans-serif" }}
              >
                {footerData.credentials}
              </p>
            </div>
          </div>

          {/* Company Info */}
          <div>
            <p
              className="text-[#dfddd6] text-sm mb-2"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {footerData.company}
            </p>
            <p
              className="text-[#888680] text-xs leading-relaxed mb-3"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {footerData.serving}
            </p>
            <a
              href={`mailto:${footerData.email}`}
              className="inline-flex items-center gap-2 text-[#888680] text-xs transition-colors hover:text-[#dfddd6]"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              <Mail size={13} className="text-[#3f4816]" />
              {footerData.email}
            </a>
          </div>

          {/* Social */}
          <div>
            <p
              className="text-[#888680] text-xs font-semibold mb-3 uppercase tracking-wider"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {footerData.social.handle}
            </p>
            <div className="flex items-center gap-3 flex-wrap">
              <a
                href={footerData.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 border border-[#3f4816]/30 rounded-full flex items-center justify-center text-[#888680] transition-all duration-300 hover:border-[#3f4816]/60 hover:text-[#dfddd6]"
                aria-label="Instagram"
              >
                <Instagram size={16} />
              </a>
              <a
                href={footerData.social.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 border border-[#3f4816]/30 rounded-full flex items-center justify-center text-[#888680] transition-all duration-300 hover:border-[#3f4816]/60 hover:text-[#dfddd6]"
                aria-label="YouTube"
              >
                <Youtube size={16} />
              </a>
              <a
                href={footerData.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 border border-[#3f4816]/30 rounded-full flex items-center justify-center text-[#888680] transition-all duration-300 hover:border-[#3f4816]/60 hover:text-[#dfddd6]"
                aria-label="LinkedIn"
              >
                <Linkedin size={16} />
              </a>
              <a
                href={footerData.social.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 border border-[#3f4816]/30 rounded-full flex items-center justify-center text-[#888680] transition-all duration-300 hover:border-[#3f4816]/60 hover:text-[#dfddd6]"
                aria-label="TikTok"
              >
                {/* TikTok SVG */}
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.51a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.46V13a8.28 8.28 0 005.58 2.15v-3.44a4.85 4.85 0 01-2.65-.78v-4.24h2.65z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-[#3f4816]/20 flex flex-col md:flex-row items-center justify-between gap-3">
          <p
            className="text-[#888680]/50 text-xs"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            &copy; {new Date().getFullYear()} Finpire Global. All rights reserved.
          </p>
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="text-[#888680]/50 text-xs flex items-center gap-1 transition-colors hover:text-[#dfddd6]"
          >
            Back to top <ArrowUpRight size={10} />
          </a>
        </div>
      </div>
    </footer>
  );
};
